// extracted by mini-css-extract-plugin
export var banner = "_g8-0";
export var closeButton = "_g8-2";
export var greenCheckmark = "_g8-3";
export var hereLink = "_g8-4";
export var titleIcon = "_g8-1";